import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBasketFAQ} from '../hooks/useGetBasketPageSection';
import {BasketFAQSkeleton} from './BasketFAQ.skeleton';
import {BasketFAQView} from './BasketFAQView';

export const BasketFAQ = () => {
  return (
    <DataFetcher
      request={useBasketFAQ()}
      Error={() => null}
      View={BasketFAQView}
      Loading={BasketFAQSkeleton}
    />
  );
};
